<template>
  <div class="">
    <el-dialog title="行业类型选择" :visible.sync="treedialogVisible" append-to-body width="30%">
      <div class="treedialog">
        <div class="treedialogipt">
          关键字：
          <div>
            <el-input placeholder="请输入行业" v-model="filterText"></el-input>
          </div>
        </div>
        <div class="treehy">
          <el-tree class="filter-tree" accordion :data="data" :props="defaultProps" :filter-node-method="filterNode"
            @node-click="handleNodeClick" ref="tree">
          </el-tree>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirm">确 定</el-button>
        <el-button @click="treedialogVisible = false">关 闭</el-button>

      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "TreedialogView",
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  data() {
    return {
      treedialogVisible: false,
      filterText: '',
      // 选中的信息
      selected: null,
      data: [{
        id: 1,
        label: '一级 1',
        children: [{
          id: 4,
          label: '二级 1-1',
          children: [{
            id: 9,
            label: '三级 1-1-1'
          }, {
            id: 10,
            label: '三级 1-1-2'
          }]
        }]
      }, {
        id: 2,
        label: '一级 2',
        children: [{
          id: 5,
          label: '二级 2-1'
        }, {
          id: 6,
          label: '二级 2-2'
        }]
      }, {
        id: 3,
        label: '一级 3',
        children: [{
          id: 7,
          label: '二级 3-1'
        }, {
          id: 8,
          label: '二级 3-2'
        }]
      }],
      defaultProps: {
        children: 'children',
        label: 'label'
      }
    };
  },
  methods: {
    show() {
      this.treedialogVisible = true
    },
    confirm() {
      if (this.selected) {
        this.$emit('getSelected', this.selected)
        this.selected = null
        this.treedialogVisible = false
      } else {
        this.$message.warning('请选择行业');
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    handleNodeClick(data) {
      this.selected = data
    }
  }

};
</script>

<style lang="scss">
.treedialog {
  .treedialogipt {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }
}
</style>